import React from 'react'
import { TopNav } from 'components/Nav'
import { useRequireAuth } from '@/common/utils'
import { HeadMeta } from '@/components/HeadMeta'
import { ChatWidget } from '@/components/ChatWidget'
import { useAutoCheckin } from '@/components/DisplayCheckIn'

type Props = React.PropsWithChildren & {
  title?: string
  width?: number
  showNav?: boolean
  description?: string
  requireAuth?: boolean
}

function Loading() {
  return (
    <div className="flex items-center justify-center">
      <div role="status" className="p-8">
        <span className="text-lg">Loading...</span>
      </div>
    </div>
  )
}

function HomeLayout({
  children,
  title = '',
  showNav = true,
  description = '',
  requireAuth = false,
}: Props) {
  const user = useRequireAuth(requireAuth)
  useAutoCheckin(user)

  return (
    <>
      <HeadMeta title={title} description={description} />
      {showNav ? <TopNav /> : ''}
      {requireAuth == true && !user ? <Loading /> : children}
      <ChatWidget user={user} />
    </>
  )
}

export default HomeLayout
